import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';
import Loading from 'Components/Atoms/Loading/Loading';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';

// Solo deja entrar a las rutas hijas si el feature flag de PostHog está activo; si no, redirige a `redirectTo`.
export default function GuardFeatureFlag({ flag, redirectTo }) {
    const { enabled, isloading } = useFeatureFlag(flag);

    if (isloading) {
        return (
            <div className="flex justify-center py-16">
                <Loading />
            </div>
        );
    }

    if (!enabled) {
        return <Navigate to={redirectTo} replace />;
    }

    return <Outlet />;
}

GuardFeatureFlag.propTypes = {
    flag: PropTypes.string.isRequired,
    redirectTo: PropTypes.string.isRequired,
};
